export const DropCatchWebApi = {
  addFabalFunds: { endpoint: '/AddFabalFunds' },
  addPaymentMethod: { endpoint: '/AddPaymentMethod' },
  authorize: { endpoint: '/authorize' },
  buyingHistoryDownload: { endpoint: '/History/Download' },
  buyingHistoryFilters: { endpoint: '/History/Filters' },
  buyingHistorySearch: { endpoint: '/History/Search' },
  buyingHistoryReceipt: { endpoint: '/GetPurchaseReceiptByReferenceId' },
  cancelBackorder: { endpoint: '/CancelBackorders' },
  cancelPrivateSellerItem: { endpoint: '/CancelPrivateSellerItem' },
  checkSuspension: { endpoint: '/CheckSuspension' },
  contactUs: { endpoint: '/ContactUs' },
  createAccount: { endpoint: '/CreateAccount' },
  filters: { endpoint: '/Filters' },
  getAccount: { endpoint: '/GetAccount' },
  getAuction: { endpoint: '/GetAuction' },
  getAuctions: { endpoint: '/GetAuctions' },
  getAuctionBidHistory: { endpoint: '/GetAuctionBidHistory' },
  getAuctionSummary: { endpoint: '/GetAuctionSummary' },
  getBackorderPolicies: { endpoint: '/GetBackorderPolicies' },
  getFallbackAuctionData: { endpoint: '/GetRecentAuctions' },
  getCart: { endpoint: '/GetCart' },
  getCountries: { endpoint: '/GetCountries' },
  getCountry: { endpoint: '/GetCountry' },
  getDomainDetail: { endpoint: '/GetDomainDetail' },
  getEmailNotifications: { endpoint: '/GetEmailNotification' },
  getFileUrl: { endpoint: '/GetFileUrl' },
  getGlobalNotifications: { endpoint: '/GetGlobalNotifications' },
  getHistoryDownload: { endpoint: '/DownloadHistory' },
  getPasswordStrength: { endpoint: '/GetPasswordStrength' },
  getPhoneNumberValidation: { endpoint: '/GetPhoneNumberValidation' },
  getPrivateSellerItems: { endpoint: '/GetPrivateSellerItems' },
  getPurchaseReceipt: { endpoint: '/GetPurchaseReceipt' },
  getPurchaseReceipts: { endpoint: '/GetPurchaseReceipts' },
  getToken: { endpoint: '/GetToken' },
  getWallet: { endpoint: '/GetOrCreateWallet' },
  legalDocs: { endpoint: '/GetLegalDoc' },
  logoff: { endpoint: '/logoff' },
  myAccountSearch: { endpoint: '/MyAccountSearch' },
  placeBid: { endpoint: '/PlaceBid' },
  bulkPlaceBid: { endpoint: '/BulkPlaceBid' },
  placeOrder: { endpoint: '/PlaceOrder' },
  purchaseReceiptsDownload: { endpoint: '/PurchaseReceipts/Download' },
  invoiceReceiptsDownload: { endpoint: '/Invoice/Download' },
  refresh: { endpoint: '/refreshtoken' },
  removePaymentMethod: { endpoint: '/RemovePaymentMethod' },
  search: { endpoint: '/Search' },
  startPrivateSellerAuction: { endpoint: '/StartPrivateSellerAuction' },
  submitPhotoVerification: { endpoint: '/SubmitPhotoVerification' },
  updateAccount: { endpoint: '/UpdateAccount' },
  setAlias: { endpoint: '/SetAlias' },
  updateDefaultPaymentMethod: { endpoint: '/UpdateDefaultPaymentMethod' },
  updateEmailNotifications: { endpoint: '/UpdateEmailNotification' },
  updatePrivateSellerItem: { endpoint: '/UpdatePrivateSellerItem' },
  uploadPrivateSellerFile: { endpoint: '/UploadPrivateSellerFile' },
  uploadPrivateSellerText: { endpoint: '/UploadPrivateSellerText' },
  upsertBackordersByDomainName: { endpoint: '/UpsertBackordersByDomainName' },
  validateAlias: { endpoint: '/ValidateAlias' },
  validateEmail: { endpoint: '/ValidateEmail' },
  validateUsername: { endpoint: '/ValidateUsername' },
  getMilliseconds: { endpoint: '/GetMilliseconds' },
  checkRateLimit: { endpoint: '/CheckRateLimit' },
  getApiClients: { endpoint: '/GetApiClients' },
  toggleClient: { endpoint: '/ToggleClient' },
  resetClientPassword: { endpoint: '/ResetClientPassword' },
  forgotClientPassword: { endpoint: '/SendForgotPassword' },
  createClient: { endpoint: '/CreateClient' },
  saveSearch: { endpoint: '/SaveSearch' },
  findSavedSearches: { endpoint: '/findSavedSearches' },
  deleteSearch: { endpoint: '/deleteSearch' },
  updateSearchName: { endpoint: '/updateSearchName' },
};
